import { useContext, useState, useEffect } from 'react';
import styles from './VacancyList.module.scss';
import StatesContext from '../../context/states';
import VacancyCard from '../VacancyCard';
import CollapseVacancy from '../CollapseVacancy/CollapseVacancy';
import Form from '../Form';

const OTHER_SCOPE_ID = 'other';

const match = (ids, entity) => !ids || (entity && ids.includes(entity.id));

const VacancyList = ({ data, isInternship }) => {
  const states = useContext(StatesContext);
  const {
    dataVacancy,
    queriesFilter,
    dataFilter,
    updateHrefVacancy,
    updateHrefInternship,
    updateVacancyLength,
  } = states;

  const source = data !== undefined ? data : dataVacancy;
  const updateHref = isInternship ? updateHrefInternship : updateHrefVacancy;

  const [currentData, setCurrentData] = useState(null);
  const [currentLength, setCurrentLength] = useState(0);

  let contentArray = {};
  let content = [];

  useEffect(() => {
    if (!source) return;

    if (!queriesFilter) {
      setCurrentData(source);

      return;
    }

    const { employments, experiences, cities, scopes } = queriesFilter;

    const filtered = source.filter(
      ({ employment, experience, city, scope }) =>
        match(employments, employment) &&
        match(experiences, experience) &&
        match(cities, city) &&
        match(scopes, scope)
    );

    setCurrentData(filtered);
  }, [source, queriesFilter]);

  useEffect(() => {
    if (currentData && currentData.length !== currentLength) {
      setCurrentLength(currentData.length);
      updateVacancyLength(currentData.length);
    }
  }, [currentData, currentLength, updateVacancyLength]);

  if (currentData && currentData.length > 0) {
    dataFilter.scopes.forEach((scope) => {
      contentArray[scope.id] = [];
    });
    contentArray[OTHER_SCOPE_ID] = [];

    currentData.forEach((element, i) => {
      const card = (
        <div className={styles.card} key={`card-${i}`}>
          <VacancyCard
            title={element.name}
            exp={element.experience.name}
            city={element.city.name}
            type={element.employment.name}
            href={element.id}
            updateHrefVacancy={updateHref}
            isInternship={isInternship}
          />
        </div>
      );

      if (element.scope) {
        contentArray[element.scope.id]?.push(card);
      } else {
        contentArray[OTHER_SCOPE_ID].push(card);
      }
    });

    dataFilter.scopes.forEach((scope, i) => {
      const items = contentArray[scope.id];

      if (items && items.length > 0) {
        content.push(
          <div className={styles.section} key={`section-${i}-${scope.id}`}>
            <div className={styles.title}>{scope.name}</div>
            <div className={styles.collapse}>
              <CollapseVacancy
                size="big"
                align="center"
                count={4}
                data={items}
                toggler="Смотреть все"
              />
            </div>
          </div>
        );
      }
    });

    const otherItems = contentArray[OTHER_SCOPE_ID];

    if (otherItems.length > 0) {
      content.push(
        <div className={styles.section} key="section-other">
          <div className={styles.title}>Другие вакансии</div>
          <div className={styles.collapse}>
            <CollapseVacancy
              size="big"
              align="center"
              count={4}
              data={otherItems}
              toggler="Смотреть все"
            />
          </div>
        </div>
      );
    }
  }

  return (
    <div className={styles.wrap}>
      {content.length > 0 ? (
        content
      ) : currentData && !isInternship ? (
        <div className={styles.form}>
          <div className={styles.form__title}>
            Не нашли подходящей вакансии?
          </div>
          <div className={styles.form__text}>
            Заполните форму ниже. Если появится вакансия, мы обязательно с вами
            свяжемся
          </div>
          <div className={styles.form__element}>
            <Form />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default VacancyList;
